import { API_ENDPOINTS } from '@/constants';
import { apiRequest } from '@/services/client';
import {
  type LoginTokensResponseContract,
  validateLoginTokensResponse,
} from '@/services/shared/contractValidation';
import type { LoginTokensResponse } from '@/types/auth';

export const refreshAuthToken = async (
  refreshToken: string,
): Promise<LoginTokensResponse> => {
  const response = await apiRequest<LoginTokensResponseContract>(
    API_ENDPOINTS.AUTH.REFRESH,
    {
      method: 'POST',
      data: { refresh_token: refreshToken },
      skipAuthRefresh: true,
      useGlobalErrorHandler: false,
      retry: { retries: 1, retryDelayMs: 400 },
    },
  );
  return validateLoginTokensResponse(response, {
    operation: 'refresh_auth_token',
    endpoint: API_ENDPOINTS.AUTH.REFRESH,
  });
};
